import { createFileRoute } from "@tanstack/react-router";

import { loadInPlace } from "../data/ensure.ts";
import { useViewer } from "../data/hooks.ts";
import { loadLogbook } from "../logbook/loaders.ts";
import { LogbookPage } from "../logbook/logbook-page.tsx";
import { logbookSearch, retainPropertyFilter } from "../shell/search.ts";
import { NoAccessPage } from "../shell/status-pages.tsx";
import { TasksPending } from "../tasks/pending.tsx";

import type { ReactElement } from "react";

const Page = (): ReactElement => {
  const viewer = useViewer();
  return viewer === null || viewer.role === "vendor" ? <NoAccessPage /> : <LogbookPage viewer={viewer} />;
};

export const Route = createFileRoute("/_app/logbook/")({
  staticData: { hasPropertyContext: true },
  validateSearch: logbookSearch,
  search: retainPropertyFilter(),
  loader: async ({ context, location, cause }) =>
    loadInPlace(cause, async () => loadLogbook(context.data, logbookSearch.parse(location.search))),
  pendingComponent: TasksPending,
  component: Page,
});
